import axios from "axios";
import Config from "../config";

export const createEvent = async (token, eventName, templateId, sourceData) => {
    let fd = new FormData();

    fd.append("token", JSON.stringify(token))
    fd.append("identity", "wmhandler");
    fd.append("clientId", token?.id)
    fd.append("eventName", eventName);
    fd.append("templateId", templateId);
    fd.append("sourceData", sourceData);

    return await axios({
        method: "POST",
        url: `${Config.apiUrl}/Certificate/createEvent`,
        data: fd
    })
}

export const getEvents = async (token,clientId) => {
    let fd = new FormData();

    fd.append("token", JSON.stringify(token));
    // fd.append("identity", "web");
    fd.append("identity", "wmhandler");

    fd.append("screenName", "EVENT");
    fd.append("client_id",clientId)
    return await axios({
        method: "POST",
        url: `${Config.apiUrl}Certificate/showClient`,
        data: fd
    })
}

export const getEventData = async (token,eventId,email)=>{
    let fd = new FormData();

    fd.append("token", JSON.stringify(token));
    fd.append("identity", "wmhandler");
    fd.append("eventId",eventId)
    fd.append("email",email)
    return await axios({
        method: "POST",
        url: `${Config.apiUrl}Certificate/getEventData`,
        data: fd
    })
}